import { cn } from "@design-lab/shared/lib";
import type { HTMLAttributes } from "react";
import { SpaceHolderItem } from "./SpaceHolderItem";

/**
 * SpaceHolder is a utility component that creates a single-cell grid container.
 * All its children are rendered in the same grid cell, and the cell's size is determined
 * by the largest child. This approach is similar to using absolute positioning for children,
 * but without removing them from the document flow.
 *
 * The main use case is to prevent layout shifts or content jumping when switching between
 * different children (e.g., from a loading state to a loaded state), ensuring the container
 * always reserves enough space for the largest possible child.
 *
 * Example usage:
 *   <SpaceHolder>
 *     <SpaceHolder.Item visible={isLoading}>Loading...</SpaceHolder.Item>
 *     <SpaceHolder.Item visible={!isLoading}>Loaded content</SpaceHolder.Item>
 *   </SpaceHolder>
 */

export function SpaceHolder(props: HTMLAttributes<HTMLDivElement>) {
  return <div {...props} className={cn(props.className, "grid")} />;
}

SpaceHolder.Item = SpaceHolderItem;
